"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UITile = _interopRequireDefault(require("UIComponents/tile/UITile"));

var _UITileSection = _interopRequireDefault(require("UIComponents/tile/UITileSection"));

var _LegalConsentOptions = _interopRequireDefault(require("MeetingsBase/models/LegalConsentOptions"));

var _LegalConsentFields = _interopRequireDefault(require("FormsCommonComponents/LegalConsentFields"));

var _LegalConsent = _interopRequireDefault(require("FormsCommonComponents/lib/LegalConsent"));

var _colors = require("HubStyleTokens/colors");

var LegalConsentInputs = function LegalConsentInputs(_ref) {
  var legalConsentOptions = _ref.legalConsentOptions,
      legalConsentResponses = _ref.legalConsentResponses,
      setGivenConsent = _ref.setGivenConsent;
  var previewModel = new _LegalConsent.default(legalConsentOptions.convertToJSON());
  return _react.default.createElement(_UITile.default, {
    style: {
      background: _colors.KOALA
    },
    compact: true
  }, _react.default.createElement(_UITileSection.default, {
    className: "p-bottom-0",
    style: {
      wordWrap: 'break-word'
    }
  }, _react.default.createElement(_LegalConsentFields.default, {
    legalConsentRecord: previewModel,
    legalConsentResponses: legalConsentResponses,
    onCommunicationCheckboxChange: setGivenConsent
  })));
};

LegalConsentInputs.propTypes = {
  legalConsentOptions: _propTypes.default.instanceOf(_LegalConsentOptions.default).isRequired,
  legalConsentResponses: _propTypes.default.instanceOf(_immutable.List),
  setGivenConsent: _propTypes.default.func.isRequired
};
var _default = LegalConsentInputs;
exports.default = _default;
module.exports = exports.default;